import { render } from "./I18nWithCurrentYear.vue?vue&type=template&id=4eb155d1"
import script from "./I18nWithCurrentYear.vue?vue&type=script&lang=js"
export * from "./I18nWithCurrentYear.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__